import { render, staticRenderFns } from "./PreviewMails.vue?vue&type=template&id=895dec54&scoped=true&"
import script from "./PreviewMails.vue?vue&type=script&lang=js&"
export * from "./PreviewMails.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMails.vue?vue&type=style&index=0&id=895dec54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895dec54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
